/* eslint-disable max-statements,complexity */
import {PAYMENTS} from '../../constants/paymentStep';
import {
    formDataPaymentsRecurly,
    formDataPaymentsOS,
    formDataDefault,
    orderFormDataPaymentsOS,
    formDataPaymentsKlarna,
    formDataPaymentsStripe,
    formDataAmazonV2ForSavePayment,
    formDataAmazonV2ForOrder,
    formDataGooglePay,
    formDataApplePay,
    formDataPayPalV3,
    orderFormDataVenmo,
    orderFormDataPrimerCC,
} from '../formDataPaymentMethods/formDataPaymentMethods';

/**
 * Create payload for save payment request according to payment method
 *
 * @param {string} method - payment method code
 * @param {object} paymentDetails - required data for payment method
 * @returns {FormData} payload for save payment request
 */
export const createPayloadForSavePayment = (method: string, paymentDetails: object) => {
    // @ts-expect-error
    const {formKey, paymentInfo = {}} = paymentDetails;
    switch (method) {
        case PAYMENTS.METHOD_CREDIT_CARD: {
            return formDataPaymentsOS({
                affid: paymentInfo?.affid,
                save: paymentInfo?.save,
                token: paymentInfo?.token,
            });
        }
        case PAYMENTS.METHOD_RECURLY:
        case PAYMENTS.METHOD_RECURLY_PAYPAL: {
            return formDataPaymentsRecurly({
                affid: paymentInfo?.affid,
                method,
                token: paymentInfo?.token,
            });
        }
        case PAYMENTS.METHOD_KLARNA: {
            return formDataPaymentsKlarna(paymentInfo);
        }
        case PAYMENTS.METHOD_STRIPE: {
            return formDataPaymentsStripe(paymentInfo);
        }
        case PAYMENTS.METHOD_AMAZON_V2: {
            return formDataAmazonV2ForSavePayment(paymentInfo, formKey);
        }
        case PAYMENTS.METHOD_GOOGLE_PAY: {
            return formDataGooglePay(paymentInfo, formKey);
        }
        case PAYMENTS.METHOD_PAYPAL_V3: {
            return formDataPayPalV3(paymentInfo, formKey);
        }
        case PAYMENTS.METHOD_APPLE_PAY: {
            return formDataApplePay(paymentInfo, formKey);
        }
        default: {
            return formDataDefault(paymentInfo, formKey);
        }
    }
};

/**
 * Create payload for create order request according to payment method
 *
 * @param {string} method - payment method code
 * @param {object} paymentDetails - required data for payment method
 * @returns {FormData} payload for create order request
 */
export const createPayloadForOrder = (method: string, paymentDetails: object) => {
    // @ts-expect-error
    const {formKey, paymentInfo} = paymentDetails;
    switch (method) {
        case PAYMENTS.METHOD_CREDIT_CARD: {
            return orderFormDataPaymentsOS({
                affid: paymentInfo?.affid,
                cvv: paymentInfo?.cvv,
                subscribe: paymentInfo?.subscribe,
                token: paymentInfo?.token,
            });
        }
        case PAYMENTS.METHOD_RECURLY:
        case PAYMENTS.METHOD_RECURLY_PAYPAL: {
            return formDataPaymentsRecurly({
                affid: paymentInfo.affid,
                method,
                subscribe: paymentInfo.subscribe,
                token: paymentInfo?.token,
            });
        }
        case PAYMENTS.METHOD_KLARNA: {
            return formDataPaymentsKlarna(paymentInfo);
        }
        case PAYMENTS.METHOD_STRIPE: {
            return formDataPaymentsStripe(paymentInfo);
        }
        case PAYMENTS.METHOD_AMAZON_V2: {
            return formDataAmazonV2ForOrder(paymentInfo);
        }
        case PAYMENTS.METHOD_VENMO: {
            return orderFormDataVenmo(paymentInfo);
        }
        case PAYMENTS.METHOD_PRIMER: {
            return orderFormDataPrimerCC(paymentInfo, formKey);
        }
        default: {
            return formDataDefault(paymentInfo, formKey);
        }
    }
};
